import { computed } from '@vue/composition-api'

export default ({ state, prop }) =>
  computed({
    get: () => state[prop],
    set: value => {
      state[prop] = value
    }
  })
